<template>
    <section class="bg-white py-10" id="trocar-contador">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 text-center">
                    <h2>
                        Traga sua contabilidade para a
                        {{ app.nome }}. É simples, é seguro
                    </h2>
                    <p class="lead mb-10">
                        Você pode trocar de contador a qualquer momento do ano,
                        sem custos! <br />
                        Confira os passos:
                    </p>
                </div>
            </div>
            <div class="row text-center">
                <div class="col-lg-4 mb-5 mb-lg-0">
                    <div
                        class="icon-stack icon-stack-xl bg-gradient-primary-to-secondary text-white mb-4"
                    >
                        <i data-feather="layers"></i>
                    </div>
                    <h3>Solicite uma proposta</h3>
                    <p class="mb-0">
                        Preencha seus dados no formulário para trocar de
                        contador e solicite uma proposta.
                    </p>
                </div>
                <div class="col-lg-4 mb-5 mb-lg-0">
                    <div
                        class="icon-stack icon-stack-xl bg-gradient-primary-to-secondary text-white mb-4"
                    >
                        <i data-feather="smartphone"></i>
                    </div>
                    <h3>Converse com nossos especialistas</h3>
                    <p class="mb-0">
                        Fale com um consultor e faça uma revisão do atual
                        cenário contábil e fiscal da sua empresa.
                    </p>
                </div>
                <div class="col-lg-4">
                    <div
                        class="icon-stack icon-stack-xl bg-gradient-primary-to-secondary text-white mb-4"
                    >
                        <i data-feather="code"></i>
                    </div>
                    <h3>Envie a documentação</h3>
                    <p class="mb-0">
                        Nós solicitamos a documentação junto ao seu contador, ou
                        você envia os documentos necessários e assina a Proposta
                        de Serviços e damos início à nossa parceria!
                    </p>
                </div>
            </div>
        </div>
        <div class="svg-border-rounded text-light">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 144.54 17.34"
                preserveAspectRatio="none"
                fill="currentColor"
            >
                <path
                    d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"
                ></path>
            </svg>
        </div>
    </section>
</template>
<script>
export default {
    props: ['app']
}
</script>
